import type { ColumnPlugin, ColumnPluginContext } from "app/pages/sales-intelligence/common-components/column-picker";
import { UpgradeColumnButton } from "app/pages/sales-intelligence/common-components/column-picker/components/UpgradeColumnButton";
import { LegacyBadge } from "app/pages/sales-intelligence/common-components/badge/LegacyBadge";
import AdIntelligenceUpgradeBanner from "app/pages/sales-intelligence/common-components/feature-upgrade/AdIntelligenceUpgradeBanner";
import ConversionRateBanner from "app/pages/sales-intelligence/common-components/feature-upgrade/components/ConversionRate";

import type { ColumnPickerPlugins, UpgradePluginConfig } from "./types";

const LEGACY_INDUSTRY_COLUMN_ID = "industry";

const AD_INTELLIGENCE_UPGRADE_PLUGIN = "adIntelligenceUpgrade" as const;
const CONVERSION_RATE_UPGRADE_PLUGIN = "conversionRateUpgrade" as const;

/**
 * AdIntelligence-related plugins for column picker.
 */
export const adIntelligenceColumnPickerPlugins: ColumnPickerPlugins = {
    createUpgradeButton: (config: UpgradePluginConfig): ColumnPlugin => ({
        id: AD_INTELLIGENCE_UPGRADE_PLUGIN,
        slot: "column-action",
        behavior: "substitute",
        shouldRender: (context: ColumnPluginContext) => context.column.upgradePlugin === AD_INTELLIGENCE_UPGRADE_PLUGIN,
        render: () => ({
            priority: 1,
            component: (
                <UpgradeColumnButton
                    tooltipContent={
                        <AdIntelligenceUpgradeBanner
                            hasHeader
                            variant="column"
                            isSubmitted={config.isHookSubmitted}
                            onSubmit={config.onHookSubmit}
                        />
                    }
                />
            ),
        }),
    }),
};

/**
 * Legacy industry column badge for column picker.
 */
export const legacyIndustryColumnPickerPlugins = {
    createLegacyBadge: (): ColumnPlugin => ({
        id: "legacy-industry-badge",
        slot: "column-badge",
        behavior: "extend",
        shouldRender: (context: ColumnPluginContext) => context.column.id === LEGACY_INDUSTRY_COLUMN_ID,
        render: () => ({
            priority: 1,
            component: <LegacyBadge />,
        }),
    }),
};

/**
 * ConversionRate-related plugins for column picker.
 */
export const conversionRateColumnPickerPlugins: ColumnPickerPlugins = {
    createUpgradeButton: (config: UpgradePluginConfig): ColumnPlugin => ({
        id: CONVERSION_RATE_UPGRADE_PLUGIN,
        slot: "column-action",
        behavior: "substitute",
        shouldRender: (context: ColumnPluginContext) => context.column.upgradePlugin === CONVERSION_RATE_UPGRADE_PLUGIN,
        render: () => ({
            priority: 1,
            component: (
                <UpgradeColumnButton
                    tooltipContent={
                        <ConversionRateBanner
                            variant="column"
                            isSubmitted={config.isHookSubmitted}
                            onSubmit={config.onHookSubmit}
                        />
                    }
                />
            ),
        }),
    }),
};
